const increasedTapZone = function () {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
  return {
    hitSlop: {
      top: size,
      bottom: size,
      left: size,
      right: size
    }
  };
};

export { increasedTapZone };
//# sourceMappingURL=index.js.map